import * as React from 'react';
import Progress from 'react-bootstrap/ProgressBar';
import { CustomProgressBarProps } from './CustomProgressBar.types';

export const CustomProgressBar: React.FC<CustomProgressBarProps> = (props) => {
  return (
    <>
      <div className='file-tracker__progress-outer'>
        <div className='file-tracker__progress-inner'>
          {props.now?.toFixed(0)}%
        </div>
        <Progress className='file-tracker__progress-progress' now={props.now} {...(props.animated && { animated: true })} />
      </div>
    </>
  );
};